var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H7C7.2652 8 7.5196 7.8946 7.7071 7.7071C7.8946 7.5196 8 7.2652 8 7V1C8 0.73478 7.8946 0.48043 7.7071 0.29289C7.5196 0.10536 7.2652 0 7 0H1C0.73478 0 0.48043 0.10536 0.29289 0.29289C0.10536 0.48043 0 0.73478 0 1V7C0 7.2652 0.10536 7.5196 0.29289 7.7071C0.48043 7.8946 0.73478 8 1 8ZM2 2H6V6H2V2ZM17 0H11C10.7348 0 10.4804 0.10536 10.2929 0.29289C10.1054 0.48043 10 0.73478 10 1V7C10 7.2652 10.1054 7.5196 10.2929 7.7071C10.4804 7.8946 10.7348 8 11 8H17C17.2652 8 17.5196 7.8946 17.7071 7.7071C17.8946 7.5196 18 7.2652 18 7V1C18 0.73478 17.8946 0.48043 17.7071 0.29289C17.5196 0.10536 17.2652 0 17 0ZM16 6H12V2H16V6ZM7 18C7.2652 18 7.5196 17.8946 7.7071 17.7071C7.8946 17.5196 8 17.2652 8 17V11C8 10.7348 7.8946 10.4804 7.7071 10.2929C7.5196 10.1054 7.2652 10 7 10H1C0.73478 10 0.48043 10.1054 0.29289 10.2929C0.10536 10.4804 0 10.7348 0 11V17C0 17.2652 0.10536 17.5196 0.29289 17.7071C0.48043 17.8946 0.73478 18 1 18H7ZM2 12H6V16H2V12ZM15 11H13V13H11V15H13V17H15V15H17V13H15V11Z",
    fill: "#001B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidget);
export default __webpack_public_path__ + "static/media/widget.ce790303159ad022caaa47ccd0ca3b3b.svg";
export { ForwardRef as ReactComponent };